export const FIREBASE_CONFIG = {
  apiKey: process.env.NX_FB_KEY,
  authDomain: process.env.NX_FB_AUTH_DOMAIN,
  databaseURL: process.env.NX_FB_DATABASE_URL,
  projectId: process.env.NX_FB_PROJECT_ID,
  messagingSenderId: process.env.NX_FB_SENDER_ID,
};
